import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CommandPalette } from "./CommandPalette";
import { RouteFallback } from "./RouteFallback";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function AppShell() {
  return (
    <div className="flex h-full">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        {/* Suspense lives INSIDE the shell so navigating between lazy /app
            routes only swaps the main panel — the sidebar + topbar stay
            mounted instead of the whole page unmounting to a full-screen
            fallback (the "nav rerenders the entire page" bug). */}
        <main className="min-h-0 flex-1 overflow-hidden">
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
